import { render, staticRenderFns } from "./statusRank.vue?vue&type=template&id=27abd18a&scoped=true"
import script from "./statusRank.vue?vue&type=script&lang=js"
export * from "./statusRank.vue?vue&type=script&lang=js"
import style0 from "./statusRank.vue?vue&type=style&index=0&id=27abd18a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abd18a",
  null
  
)

export default component.exports